import { useState, useEffect } from 'react';
import { crewsAPI, usersAPI, trainingGroupsAPI } from '../services/api';
import { useNotifications } from '../components/notifications';

export const useCrewsData = () => {
  const [crews, setCrews] = useState([]);
  const [availableRowers, setAvailableRowers] = useState([]);
  const [trainingGroups, setTrainingGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCrew, setSelectedCrew] = useState(null);
  const { showToast } = useNotifications();

  const loadData = async () => {
    try {
      setLoading(true);
      const [crewsData, usersData, groupsData] = await Promise.all([
        crewsAPI.getCrews(),
        usersAPI.getUsers({ role: 'rower' }),
        trainingGroupsAPI.getGroups(),
      ]);

      setCrews(crewsData);
      setAvailableRowers(usersData);
      setTrainingGroups(groupsData);
    } catch (error) {
      console.error('Error loading data:', error);
      showToast('Failed to load data', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const refetchCrews = async () => {
    try {
      const crewsData = await crewsAPI.getCrews();

      setCrews(crewsData);

      // If there's a selected crew, update it with the fresh data
      if (selectedCrew) {
        const updatedSelectedCrew = crewsData.find((crew) => crew.id === selectedCrew.id);
        if (updatedSelectedCrew) {
          setSelectedCrew(updatedSelectedCrew);
        }
      }
    } catch (error) {
      console.error('Error refetching crews:', error);
    }
  };

  return {
    crews,
    setCrews,
    availableRowers,
    trainingGroups,
    loading,
    loadData,
    refetchCrews,
    selectedCrew,
    setSelectedCrew,
  };
};
